import { render } from "./UserCenter.vue?vue&type=template&id=f79091b4&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=f79091b4&scoped=true&lang=css"
import "./UserCenter.vue?vue&type=style&index=1&id=f79091b4&lang=css"

import exportComponent from "/root/.jenkins/workspace/WJ-WEB/htweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79091b4"]])

export default __exports__